import store from '../store/index'

export default function (to, from, next) {
    store.dispatch('setAuthorizedStatus');
    if (store.getters.isAuthorized) {
        Promise.all([
            store.dispatch('getUser'),
        //    store.dispatch('getProjects')
        ]).then(() => {
            if (store.getters.isAuthorized) {
                if (to.fullPath == '/login') next('/');
                else next();
            } else {
                next('/login');
            }
        })
        .catch(() => {});

    } else {
        next('/login');
    }
}
